function fmtDate(iso) {
  if (!iso) return "";
  // Accept "YYYY-MM-DD" or full ISO; render dd/mm/yyyy in CDMX-friendly format
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "";
  return `${m[3]}/${m[2]}/${m[1]}`;
}

export default function PressReleaseList({ items, testId = "press-list" }) {
  if (!items?.length) {
    return <p className="py-3 text-sm text-sub" data-testid={`${testId}-empty`}>Sin comunicados publicados hoy.</p>;
  }
  return (
    <ul className="border-t border-rule" data-testid={testId}>
      {items.map((p) => (
        <li key={p.id}>
          <a
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            className="headline-link group flex items-start gap-2 px-1"
            data-testid={`press-${p.id}`}
          >
            <span
              className="source-badge mt-[3px]"
              style={{ background: "#1D3557" }}
              title={p.secretaria_full}
            >
              {p.secretaria}
            </span>
            <span className="flex-1 text-[14px] leading-snug tracking-news">
              {p.title}
              <span className="ml-2 font-mono text-[10px] uppercase tracking-widest text-sub">
                · {p.secretaria_full}
                {p.date && (
                  <span className="ml-2 text-rojo" data-testid={`press-date-${p.id}`}>
                    {fmtDate(p.date)}
                  </span>
                )}
              </span>
            </span>
            <span className="ml-1 text-sub text-[11px] mt-[2px]" aria-hidden>↗</span>
          </a>
        </li>
      ))}
    </ul>
  );
}
